import * as React from 'react'
import { Link } from 'react-router-dom'

import { Site } from '../../../common/constants/siteList'
import { ILocationParams } from '../../../common/reducers/reactRouterLocation'

export interface IProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  locationParams: ILocationParams
  makeSearchLink: (params: ILocationParams, currentSite?: Site) => string
  currentSite?: Site
  hash?: string
}

const SearchLink = ({
  locationParams,
  makeSearchLink,
  currentSite,
  hash,
  children,
  ...props
}: IProps) => {
  const hashString = hash ? `#${hash}` : ''
  const linkTo = `${makeSearchLink(locationParams, currentSite)}${hashString}`
  return (
    <Link to={linkTo} {...props}>
      {children}
    </Link>
  )
}

export default SearchLink
